<template>
  <div class="manage">
    <div class="content">
      <div class="aside">
        <el-tree
          :data="person"
          node-key="ZNSBMC"
          :default-checked-keys="defaultkeys"
          :default-expand-all="true"
          show-checkbox
          :props="defaultProps"
          @check="handleCheckChange"
          @node-click="handleNodeClick"
        ></el-tree>
      </div>
      <div class="detail">
        <div v-show="peoplenews" v-for="(item, index) in datalist" :key="index" class="com">
          <div class="content-top">
            <div>
              <el-image
                :src="item[0].ZP"
                style="width: 120px; height: 110px; padding-right: 15px"
                fit="contain"
              >
                <div slot="error" class="image-slot">
                  <i
                    class="el-icon-picture-outline"
                    style="font-size: 100px"
                  ></i>
                </div>
              </el-image>
            </div>
            <div class="content-box">
              <p>
                姓名：<span>{{ item[0].YHMC }}</span>
              </p>
              <p>
                性别：<span>{{ item[0].XB | sex }}</span>
              </p>
              <p>
                岗位：<span>{{ item[0].GWMC }}</span>
              </p>
              <p>
                部门：<span>{{ item[0].BMMC }}</span>
              </p>
            </div>
          </div>
          <div style="line-height: 30px">
            <p>
              联系电话：<span>{{ item[0].LXDH }}</span>
            </p>
            <p>
              所属项目：<span>{{ item[0].ZZJGMC }}</span>
            </p>
          </div>
        </div>
        <video 
            v-show="videocall"
            id="remoteVideo"
            controls="controls"
            style="width: 550px; height: 360px"
            muted="muted"></video>
          <el-dialog title="图片" :visible.sync="dialogTableVisible">
            <p>是否保存当前图片</p>
            <img :src="imgSrc" crossorigin="anonymous" />
            <span slot="footer" class="dialog-footer">
              <el-button plain @click="dialogTableVisible = false">取消</el-button>
              <el-button type="primary" @click="onSubmit">确定</el-button>
            </span>
          </el-dialog>
        <div class="footer" v-show="peoplenews">
          <div v-show="isShow">
          <div v-if="PP === 'RunDe'">
            <el-button type="primary" @click="vi1"  v-loading="loading">视频通话</el-button>
            <el-button type="primary" @click="vi2">语音通话</el-button>
            <el-button type="primary" @click="vi3">视频监控</el-button>
          </div>
          
          <div v-else>
            <el-button type="primary" @click="vi1">视频通话</el-button>
            <el-button type="primary" @click="vi2">语音通话</el-button>
            <el-button type="primary" @click="isflag = true">发送指令</el-button>
          </div>
          </div>
        </div>
        <div class="footer" v-show="videocall">
          <el-button type="primary" @click="cutPicture">截图</el-button>
          <el-button type="primary" @click="gua">挂断通话</el-button>
        </div>
        <div>
          <video v-show="videocall" controls="controls"
            style="width: 270px; height: 220px"
            muted="muted" id="localVideo"></video>
        </div>
        <canvas id="myCanvas" v-show="picturess"></canvas>
        <el-dialog :visible.sync="isflag" width="40%" title="编辑" center>
          <div>
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入指令信息"
              v-model="textarea"
              style="border: 1px solid #2196e3; border-radius: 4px"
            >
            </el-input>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button plain @click="isflag = false">取消</el-button>
            <el-button type="primary" @click="dre">发送</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >

      <audio controls="controls"></audio>
      <span slot="footer" class="dialog-footer">
        <el-button @click="videoHandle((type = 0))">取 消</el-button>
        <el-button type="primary" @click="videoHandle((type = 1))"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { FindZZSB, FindYhxx, FindYSPTJ, getUA, getRoomId } from "@/api/api";
import { mapState } from "vuex";
import axios from "axios";
// import { delete } from 'vue/types/umd'
var userAgent = null;
var outgoingSession = null;

export default {
  components: {},
  computed: {
    ...mapState({
      zZjg: (state) => state.tab.zzjg,
      userInfo: (state) => state.tab.userInfo,
      userpwd: (state) => state.tab.userpwd,
      pz: (state) => state.tab.pz,
      showModel: (state) => state.tab.setMap,
    }),
  },
  filters: {
    sex(val) {
      if (val == 1) {
        return "男";
      } else if (val == 2) {
        return "女";
      } else {
        return "未说明";
      }
    },
  },
  
  data() {
    return {
      defaultkeys:[],// 默认选中
      loading: false,
      device_ids:[],
      myvideo: true,
      uid: "",
      picturess: true,
      dialogTableVisible: false,
      isEquipment: true, // 是否为同一个类型的设备
      PP: "", // 控制视频通话的帽子设备 ""为之前的 RunDe为新的帽子
      imgSrc: "", //截取的图片
      jiankong: 0,
      videocall: false,
      peoplenews: true,
      dialogVisible: false,
      isShow: false,
      isflag: false,
      textarea: "",
      person: [
        { ZNSBMC: "在线人员", children: [] },
        { ZNSBMC: "离线人员", children: [], disabled: true },
        // { ZNSBMC: "离线人员", children: [] },
      ],
      defaultProps: {
        children: "children",
        label: "ZNSBMC",
      },
      datalist: [],
      demoarray: [],
      demoarr: [],
      userId: "",
      appid: "",
      pkey: "",
      session_token: "",
      v_type: "",
      websock: null,
      bh:{
        BH:'ma_login'
      },
      // uploadUrl: process.env.BASE_API + "v1/general/resource/upload_video"
    };
  },
  created() {
    this.getMan();
    
    if (this.websock) {
      this.websock.close(); // 关闭websocket连接
    }
    // this.initWebSocket();
    console.log(this.$route.query,typeof(this.$route.query))
    console.log(this.$route.query.BH,typeof(this.$route.query.BH))
    let demoarr = []
    let xuanzhong = []
    if(this.$route.query.BH!==undefined){
      this.$route.query.demoarrayall.forEach(e=>{
        demoarr.push(e.SIPNUM)
        xuanzhong.push(e.ZNSBMC)
      })
    }
    setTimeout(() => {
      this.defaultkeys = xuanzhong
    }, 500);
    if(this.$route.query.BH == 1){
      this.demoarray = demoarr
      this.uid = this.$route.query.demoarrayall[0].ZNSBMC
      this.vi22()
    }
    if(this.$route.query.BH == 2){
      this.demoarray = demoarr
      this.uid = this.$route.query.demoarrayall[0].ZNSBMC
      this.vi11()
    }
    // console.log(this.defaultkeys)
  },
  watch: {
    datalist(n) {
      n.length === 0 ? (this.isShow = false) : (this.isShow = true);
    },
  },
  destroyed() {
    //页面销毁时关闭ws连接
    this.$route.query=null
    if (this.websock) {
      this.websock.close(); // 关闭websocket
    }
  },
  mounted(){
  },
  methods: {
    getMan() {
      FindZZSB({}).then((res) => {
        this.online = [];
        this.offline = [];
        let countAry = JSON.parse(res.data.data);
        // console.log(JSON.parse(res.data.data), "智能设备");
        countAry.forEach((e) => {
          if (e.SBZT === 1) {
            this.person[0].children.push(e);
          } else {
            e.disabled = true;
            this.person[1].children.push(e);
          }
        });
      });
    },
    handleAvatarSuccess(res, file) {
      console.log(res)
      console.log(file)
        this.imageUrl = URL.createObjectURL(file.raw);
      },
    // 测试长连接登录开始=============================================================
    //初始化登录websocket
    initWebSocket() {
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持WebSocket");
        return false;
      }
      const wsuri = "wss://caps.runde.pro/wss";
      console.log(wsuri);
      this.websock = new WebSocket(wsuri);
      console.log(this.websock);
      this.websock.onopen = this.websocketonopen;
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    //连接成功
    websocketonopen() {
      console.log("WebSocket连接成功");
      const websocket = {
        act: "ma_login",
        access_token: this.session_token,
        user_name: "重庆交大交通",
      };
      console.log(JSON.stringify(websocket))
      this.websock.send(JSON.stringify(websocket));
    },
    //接收后端返回的数据，可以根据需要进行处理
    websocketonmessage(e) {
      var remoteVideo = document.getElementById("remoteVideo");
      let data1Json = JSON.parse(e.data);
      console.log(data1Json);
      const websocket = {
        act: "ma_open_group_sip_video_call",
        device_ids: this.device_ids,
      };
      if(data1Json.cmd == "ma_login"){
        console.log("发送消息")
        this.websock.send(JSON.stringify(websocket));
        console.log(JSON.stringify(websocket))
      }
      if(data1Json.cmd == "ma_open_group_sip_video_call"){
        if (data1Json.status == false) {
          this.$message(data1Json.msg);
        }
        let options = {
          sessionDescriptionHandlerOptions: {
            constraints: {
              audio: true,
              video: true,
            },
          },
        };
        //打电话
        console.log(data1Json.room_id,"room_id")
        outgoingSession = userAgent.invite(data1Json.room_id + "@47.112.144.197:6060", options);
        outgoingSession.on("accepted", (data) => {
          console.info("onAccepted - ", data);
          let pc = outgoingSession.sessionDescriptionHandler.peerConnection;
          setTimeout(() => {
            console.log(111);
            let remoteStream = new MediaStream();
            pc.getReceivers().forEach(function (receiver) {
              remoteStream.addTrack(receiver.track);
              console.log(receiver);
            });
            remoteVideo.srcObject = remoteStream;
            remoteVideo.play();
          }, 200);
          this.videocall = true
          this.peoplenews = false;
          if (pc.getSenders() && this.jiankong === 0) {
            var localStream = new MediaStream();
            pc.getSenders().forEach(function (sender) {
              localStream.addTrack(sender.track);
            });
            localVideo.srcObject = localStream;
            localVideo.play();
            console.log(localVideo.srcObject)
            console.log(localVideo.play())
          }
        });
        outgoingSession.on("rejected", (response, cause) => {
          console.log("onRejected - ", response, cause);
        });
        outgoingSession.on("failed", (response, cause) => {
          console.log("onFailed - ", response, cause);
        });
        outgoingSession.on("terminated", (message, cause) => {
          console.log("onTerminated - ", message, cause);
        });
      }
    },
    // 关闭长连接
    websocketclose(e) {
      console.log("断开连接", e);
    },
    // 获取pkey
    loginmiyao() {
      let url = "https://caps.runde.pro/api/index.php?ctl=tool&act=get_pkey&user_name=重庆交大交通&pwd=123456"
      this.$axios.post(url).then((res) => {
        console.log(res, "登录");
        this.pkey = res.data.data;
        console.log("pkey::", this.pkey);
        this.gettoken();
      });
    },
    // 获取token
    gettoken() {
      axios
        .post(
          "https://caps.runde.pro/api/index.php?ctl=tool&act=get_token&user_name=" + "重庆交大交通&pkey=" + this.pkey
        )
        .then((res) => {
          console.log(res);
          this.session_token = res.data.session_id;
          console.log("session_token::", this.session_token);
          this.initWebSocket();
        });
    },
    
    // 测试长连接登录结束=============================================================


    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    videoHandle(type) {
      console.log(type);
    },
    // 初始化通话请求websocket
    callWebSocket() {
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持WebSocket");
        return false;
      }
      const wsuri = "wss://caps.runde.pro/wss";
      console.log(wsuri);
      this.websock = new WebSocket(wsuri);
      this.websock.onopen = this.callwebsocketonopen;
      this.websock.onmessage = this.callwebsocketonmessage;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    // 通话请求连接成功
    callwebsocketonopen() {
      console.log("初始化通话WebSocket连接成功");
      const websocket = {
        act: "ma_set_sip_info",
        v_type: this.v_type,
        user_id: this.uid,
      };
      console.log(websocket, "通话请求数据");
      console.log(JSON.stringify(websocket))
      this.websock.send(JSON.stringify(websocket));
      console.log("发送消息");
    },
    // 接收后端返回的数据
    callwebsocketonmessage(e) {
      var localVideo = document.getElementById("localVideo");
      var currentSession = "";
      let data1Json = JSON.parse(e.data);
      console.log(data1Json, "返回的数据");
      if (data1Json.status == false) {
        this.$message(data1Json.msg);
        return;
      }
      console.log(this.datalist);
      // 语音通话
      if (data1Json.v_type == 0) {
        console.log(data1Json.v_type);
        console.log(this.jiankong);
        console.log("语音通话");
        let options = {
          sessionDescriptionHandlerOptions: {
            constraints: {
              audio: true,
              video: false,
            },
          },
        };
        outgoingSession = userAgent.invite(
          // "12552500@47.112.144.197:6060",
          this.demoarray[0] + "@47.112.144.197:6060",
          options
        ); //“1100200@47.112.134.21:5060”为被拨打者账号
      }
      // 视频通话
      if (data1Json.v_type == 1 && this.jiankong == 0) {
        console.log(data1Json.v_type);
        console.log(this.jiankong);
        console.log("视频通话");
        let options = {
          sessionDescriptionHandlerOptions: {
            constraints: {
              audio: true,
              video: true,
            },
          },
        };
        outgoingSession = userAgent.invite(
          this.demoarray[0] + "@47.112.144.197:6060",
          options
        ); //“1100200@47.112.134.21:5060”为被拨打者账号
      }
      // 监控
      if (data1Json.v_type == 1 && this.jiankong == 1) {
        console.log(data1Json.v_type);
        console.log(this.jiankong);
        console.log("视频监控");
        let options = {
          sessionDescriptionHandlerOptions: {
            constraints: {
              audio: true,
              video: true,
            },
          },
        };
        outgoingSession = userAgent.invite(
          this.demoarray[0] + "@47.112.144.197:6060",
          options
        ); //“1100200@47.112.134.21:5060”为被拨打者账号
      }
      currentSession = outgoingSession;
      outgoingSession.on("accepted", (data) => {
        console.log("onAccepted - ", data);
        let pc = outgoingSession.sessionDescriptionHandler.peerConnection;
        console.log(pc, "pc ");
        setTimeout(() => {
          console.log(111);
          let remoteStream = new MediaStream();
          pc.getReceivers().forEach(function (receiver) {
            remoteStream.addTrack(receiver.track);
            console.log(receiver);
          });
          remoteVideo.srcObject = remoteStream;
          remoteVideo.play();
        }, 200);
        this.videocall = true
        this.peoplenews = false;
        if (pc.getSenders() && this.jiankong === 0) {
          var localStream = new MediaStream();
          pc.getSenders().forEach(function (sender) {
            localStream.addTrack(sender.track);
          });
          localVideo.srcObject = localStream;
          localVideo.play();
          console.log(localVideo.srcObject)
          console.log(localVideo.play())
        }
      });
      outgoingSession.on("rejected", (response, cause) => {
        console.log("onRejected - ", response, cause);
      });
      outgoingSession.on("failed", (response, cause) => {
        console.log("onFailed - ", response, cause);
      });
      outgoingSession.on("terminated", (message, cause) => {
        console.log("onTerminated - ", message);
      });
    },
    
    handleCheckChange(dataa, checkdata) {
      console.log(this.videocall)
      // videocall
      if(this.videocall == true){
        this.$message("视频通话中，请勿操作！");
        return
      }
      let demolist = [];
      this.datalist = [];
      this.demoarray = [];
      this.demoarr = [];
      let SSS = [];
      let Userid = [];
      this.device_ids = []
      // this.PP = dataa.PP
      // console.log(this.PP)
      demolist = checkdata.checkedNodes.filter(
        (item) => item.children === undefined
      );
      demolist.forEach((item) => {
        this.demoarray.push(item.SIPNUM);
        Userid.push(item.ZNSBMC);
        SSS.push(item.PP);
        this.device_ids.push(item.SBBM);
        this.demoarr.push(item.ZNSBID);
        FindYhxx({ AQMID: item.ZNSBID }).then(({ data: { data } }) => {
          this.datalist.push(JSON.parse(data));
        });
      });
      console.log(Userid);
      console.log(this.device_ids)
      this.uid = Userid[0];
      const allEqual = (arr) => arr.every((val) => val === arr[0]);
      this.isEquipment = allEqual(SSS);
      if (this.isEquipment == true) {
        this.PP = SSS[0];
      }
      console.log(this.uid)
      // console.log(SSS)
      // console.log(demolist);
      console.log(this.datalist);
      // console.log(this.demoarray);
      // console.log(this.demoarr)
      // console.log(this.datalist.length)
      // console.log(this.device_ids.length)
    },
    handleNodeClick(data) {},
    // 注册UA
    regUa() {
      var remoteVideo = document.getElementById("remoteVideo");
      getUA(this.bh).then((res) => {
        console.log(res, "ua数据");
        let ua = JSON.parse(res.data.data);
        console.log(ua, "ua");
        let UA = JSON.parse(ua[0].SJZ);
        console.log(UA, "UA");
        if(UA.cmd=='ma_login'){
          var Config = {
            uri:
              UA.admin_info.sip_info.sip_id +
              "@" +
              UA.admin_info.sip_info.sip_host, //拨打者账号
            transportOptions: {
              wsServers: [UA.admin_info.sip_info.wss_url],
              connectionTimeout: 30,
            },
            authorizationUser: JSON.stringify(UA.admin_info.sip_info.sip_id),
            password: UA.admin_info.sip_info.sip_pwd,
            sessionDescriptionHandlerFactoryOptions: {
              peerConnectionOptions: {
                rtcConfiguration: {
                  iceServers: [
                    { urls: "stun:47.112.134.21:3478" },
                    {
                      urls: "turn:47.112.134.21:3478",
                      username: "fstest",
                      credential: "123456",
                    },
                  ],
                },
              },
            },
          };
          userAgent = new SIP.UA(Config);
          console.log(Config);
          console.log(this.demoarray)
          userAgent.on("registered", () => {
            if (this.demoarray.length == 1) {
              this.callWebSocket();
            } else {
              console.log("群组通话");
              // this.getRoom()
              this.loginmiyao()
            }
          });
          userAgent.on("registrationFailed", (response, cause) => {
            console.log("registrationFailed, ", response, cause);
          });
        }
        if(UA.cmd=="ma_open_group_sip_video_call"){
          let roomId = UA.room_id
          let options = {
            sessionDescriptionHandlerOptions: {
              constraints: {
                audio: true,
                video: true, //或可加入一些配置项{faceMode:’user’,width:160,height:120,frameRate:16,}，群语音通话设为false
              },
            },
          };
          //打电话
          console.log(roomId,'room_id')
          outgoingSession = userAgent.invite("9955826774" + "@47.112.144.197:6060", options);
          outgoingSession.on("accepted", (data) => {
            console.info("onAccepted - ", data);
            let pc = outgoingSession.sessionDescriptionHandler.peerConnection;
            setTimeout(() => {
              let remoteStream = new MediaStream();
              pc.getReceivers().forEach(function (receiver) {
                remoteStream.addTrack(receiver.track);
                console.log(receiver);
              });
              remoteVideo.srcObject = remoteStream;
              remoteVideo.play();
            }, 200);
            this.videocall = true
            this.peoplenews = false;
            if (pc.getSenders() && this.jiankong === 0) {
              var localStream = new MediaStream();
              pc.getSenders().forEach(function (sender) {
                localStream.addTrack(sender.track);
              });
              localVideo.srcObject = localStream;
              localVideo.play();
              console.log(localVideo.srcObject)
              console.log(localVideo.play())
            }
          });
          outgoingSession.on("rejected", (response, cause) => {
            console.log("onRejected - ", response, cause);
          });
          outgoingSession.on("failed", (response, cause) => {
            console.log("onFailed - ", response, cause);
          });
          outgoingSession.on("terminated", (message, cause) => {
            console.log("onTerminated - ", message, cause);
          });
        };
        // };
      });
    },
    // 获取room_id
    getRoom(){
      let params = {act:"ma_open_group_sip_video_call",device_ids:this.device_ids}
      getRoomId(JSON.stringify(params)).then(res=>{
        console.log(res,'room_id')
        this.bh={BH:"ma_open_group_sip_video_call"}
        this.regUa()
      })
    },
    // 视频通话
    vi11() {
      FindYhxx({ AQMID: this.$route.query.demoarrayall[0].ZNSBID }).then(({ data: { data } }) => {
        // console.log(data)
        this.datalist.push(JSON.parse(data));
      });
      console.log(this.datalist)
      this.v_type = 1;
      this.regUa();
      return;
    },
    vi1() {
      this.loading = true
      console.log(this.PP);
      if (this.isEquipment == false) {
        this.$message("请选择相同类型的设备");
        this.loading = false
        return;
      }
      if (this.PP === "RunDe") {
        this.v_type = 1;
        this.regUa();
        return;
      }
      const id =
        this.showModel === null || this.showModel === "1001"
          ? this.zZjg[0].MPROJECT_ID
          : this.showModel;
      console.log(this.pz);
      console.log(this.demoarray, "this.demoarry");

      const mao = this.pz[2].SJZ.split(",");
      const flag = this.demoarray.join(";");
      // console.log(this.demoarr)
      this.demoarray.length === 0
        ? this.$message("未选择设备")
        : (() => {
            window.open(
              `https://zmp.iwitech.net:3014/?user=${mao[0]}&passwd=${mao[1]}&type=videoCall&remoteId=${flag}`
            );
            FindYSPTJ({
              AQMID: this.demoarr,
              SIPNUM: this.demoarray,
              FQR: this.userInfo.YHBH,
              FQRXM: this.userInfo.YHMC,
              LX: 1,
              ZZJGBH: this.userInfo.SSZZJG,
              project_id: id,
            }).then((res) => {
              console.log(res);
              if (res.data.ret === "error") {
                this.$message(res.data.msg);
              }
            });
          })();
    },
    // 语音通话
    vi22(){
      FindYhxx({ AQMID: this.$route.query.demoarrayall[0].ZNSBID }).then(({ data: { data } }) => {
        // console.log(data)
        this.datalist.push(JSON.parse(data));
      });
      console.log(this.datalist)
      this.v_type = 0;
      this.regUa();
      return;
    },
    vi2() {
      this.loading = true
      if (this.isEquipment == false) {
        this.$message("请选择相同类型的设备");
        this.loading = false
        return;
      }
      if (this.PP === "RunDe") {
        this.v_type = 0;
        this.regUa();
        // this.loginmiyao();
        return;
      }
      const id =
        this.showModel === null || this.showModel === "1001"
          ? this.zZjg[0].MPROJECT_ID
          : this.showModel;
      const mao = this.pz[2].SJZ.split(",");
      const flag = this.demoarray.join(";");
      // console.log(this.demoarr)
      // console.log(this.demoarray)
      this.demoarray.length === 0
        ? this.$message("未选择设备")
        : (() => {
            window.open(
              `https://zmp.iwitech.net:3014/?user=${mao[0]}&passwd=${mao[1]}&type=videoCall&remoteId=${flag}`
            );
            FindYSPTJ({
              AQMID: this.demoarr,
              SIPNUM: this.demoarray,
              FQR: this.userInfo.YHBH,
              FQRXM: this.userInfo.YHMC,
              LX: 2,
              ZZJGBH: this.userInfo.SSZZJG,
              project_id: id,
            }).then((res) => {
              console.log(res);
              if (res.data.ret === "error") {
                this.$message(res.data.msg);
              }
            });
          })();
    },
    vi3() {
      this.loading = true
      if (this.PP === "RunDe") {
        this.v_type = 1;
        this.jiankong = 1;
        this.regUa();
        this.myvideo = false;
        // this.loginmiyao();
        return;
      }
    },
    gua() {
      if (outgoingSession) {
        console.log(outgoingSession, "gua");
        outgoingSession.terminate();
      }
      localVideo.pause();
      this.videocall = false;
      this.peoplenews = true;
      this.loading = false;
    },
    // 截屏
    cutPicture() {
      this.dialogTableVisible = true;
      this.picturess = false;
      let self = this;
      // var v = document.querySelector("video");
      let canvas = document.getElementById("myCanvas");
      var ctx = canvas.getContext("2d");
      ctx.drawImage(remoteVideo, 0, 0, 343, 200);
      // ctx.drawImage(v, 0, 0, 343, 200);
      remoteVideo.setAttribute("crossOrigin", "anonymous");
      var oGrayImg = canvas.toDataURL("image/png");
      this.imgSrc = oGrayImg;
      this.picturess = false;
      var arr = oGrayImg.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        var file = new File([u8arr], Date.now() + ".jpg", { type: mime });
        console.info(file,"图片");
        // this.onSubmit(file)
    },
    dre() {
      const mao = this.pz[2].SJZ.split(",");
      const flag = this.demoarray.join(";");
      window.open(
        `https://zmp.iwitech.net:3014/?user=${mao[0]}&passwd=${mao[1]}&type=sendMessage&message=${this.textarea}&remoteId=${flag}`
      );
      this.isflag = false;
      this.$message("发送成功");
    },
    onSubmit(file) {
      console.log(file)
      this.dialogTableVisible = false
      let loginurl = "http://150.158.5.156:8080/jeecg-boot/sys/mLogin"
      let loginparams = {username:"admin",password:"123456"}
      axios.post(loginurl, loginparams).then(res=>{
        console.log(res)
        let self = this;
        let param = new FormData();
        param.append("resourceFile", file); 
        console.log(param)
        let url = "http://150.158.5.156:8080/jeecg-boot/sys/common/upload"
        let config = {
          headers: { "Content-Type": "multipart/form-data","token": res.data.result.token },
        }; // 添加请求头
        axios.post(url , param, config).then((res) => {
          if (res.data.code === 200) {
            console.log(res)
            self.$emit("uploadSuccess", { imgUrl: res.data.data }); // 回传数据!
          }
        });
      })
      // 上传照片
      // 这里很简单 就是上传的逻辑 根据自己需要进行修改
      
      
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/common";
@import "@/assets/scss/allPage";
.manage {
  padding: 20px;
  height: 100%;
  .content {
    width: 100%;
    // height: 100%;
    background: rgba(50, 58, 82, 0.25);
    border: 1px solid rgba(122, 139, 168, 0.15);
    border-radius: 8px;
    opacity: 0.85;
    display: flex;
    justify-content: flex-start;
    padding: 15px;
    .aside {
      width: 250px;
      height: 100%;
      padding: 20px;
      // border: 1px solid hotpink;
      & /deep/ .el-tree .el-tree-node__content .el-tree-node__label {
        font-size: 16px;
      }
    }
    .detail {
      width: 80%;
      height: 100%;
      // border: 1px solid hotpink;
      padding: 10px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .com {
        border: 1px solid #fff;
        border-radius: 4px;
        padding: 5px 10px;
        margin: 5px;
        width: 270px;
        height: 220px;
        color: #fff;
        .jiepin {
          padding-top: 5px;
          display: flex;
          justify-content: space-around;
          .el-button{
            margin: 0;
            padding: 0;
          }
        }
        .content-top {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .content-box {
            width: 150px;
            line-height: 30px;
          }
        }
      }
      & /deep/ .el-dialog__wrapper {
        .el-dialog {
          .el-dialog__footer {
            background: #011d41;
            // text-align: center;
            .el-button {
              color: #fff;
              width: 120px;
              border: 1px solid rgba(33, 150, 227, 0.5);
              border-radius: 4px;
              margin: 0 10px;
            }
          }
        }
      }
    }
    .footer {
      // position: relative;
      // bottom: -50px;
      width: 100%;
      text-align: center;
      padding: 30px 0;
      & /deep/ .el-button {
        color: #fff;
        width: 150px;
        height: 36px;
        line-height: 10px;
        border: 1px solid rgba(33, 150, 227, 0.5);
        border-radius: 4px;
        margin: 0 10px;
      }
    }
  }
}
</style>
